<template>
    <div class="wrapper bg-secondary">
        <div class="sidebar bg-secondary">
            <img class="m4a_img" src="../assets/m4a.png">
            <ul>
                <router-link tag="li" to="/"><i class="fas fa-home"></i>Home</router-link>
                <router-link tag="li" to="/Report"><i class="fas fa-chart-line"></i>Reports</router-link>
                <!-- CONFIG DROPDOWN -->
                  <ul class="dropdown">
                  <li
                  class="dropdown-toggle"
                  :class="{ open: configOpen }"
                  @click="configOpen = !configOpen">
                  <i class="fa fa-cog"></i>Configuration<span class="caret"></span></li>
                  <ul class="config-submenu" v-show="configOpen">
                    <router-link tag="li" to="/Extruder"><i class="fas fa-mouse-pointer"></i>Extruder</router-link>
                    <router-link tag="li" to="/Compression"><i class="fas fa-mouse-pointer"></i>Compression</router-link>
                    <router-link tag="li" to="/Injection"><i class="fas fa-mouse-pointer"></i>Injection</router-link>
                    <router-link tag="li" to="/Corrugator"><i class="fas fa-mouse-pointer"></i>Corrugator</router-link>
                    <router-link tag="li" to="/Products"><i class="fas fa-mouse-pointer"></i>Products</router-link>
                    <router-link tag="li" to="/MachineStatus"><i class="fas fa-mouse-pointer"></i>MachineStatus</router-link>
                  </ul>
                </ul>
                <router-link tag="li" to="/Users"><i class="fas fa-users"></i>Users</router-link>
                <router-link 
                v-if="userType == 'Super Admin'"
                tag="li" 
                to="/DeviceList">
                <i class="fa fa-hdd"></i>Devices</router-link>
                <router-link v-if="userType == 'Super Admin'" tag="li" to="/Audit"><i class="fas fa-audio-description"></i>Audit Log</router-link>
                <li @click="logOut"><i class="fas fa-power-off"></i>LogOut</li>
            </ul>

            <div class="footer ">
                <p
                  class="g-matrix">Powered by <br>
                  <a href="http://g-matrixsystems.com/" target="_blank">
                    G-Matrix Systems
                  </a>
                </p>
               <router-link tag="a" to="/help" class="help">Help</router-link>
            </div>
        </div>

        <div class="main_content bg-secondary">
            <div class="header">
              <div class="factory-state">
                <label class="factory-state__label">Factory State</label>
                <select
                  class="factory-state__select"
                  :disabled="disabled"
                  v-model="current_config"
                  @change="system_conf()">
                  <option disabled value="">{{ old_config || 'Select' }}</option>
                  <option>RUNNING</option>
                  <option>POWER CUT</option>
                  <option>WEEKEND</option>
                </select>
              </div>
              <h1>m4a Production Monitoring</h1>
            </div>
                  <div class="info bg-secondary">
                  <transition name="moveInUp">
                    <router-view/>
                   </transition> 
            </div>
        </div>
    </div>
</template>

<script>
import http from '../services/http'
export default {
  data() {
    return {
      userType: '',
      configOpen: false,
      current_config: '',
      old_config: '',
      disabled: false
    }
  },

watch: {
  // collapse the Configuration menu whenever the route changes
  // (i.e. when a submenu item is picked or another nav item is clicked)
  '$route'() {
    this.configOpen = false
  }
},

mounted() {
  this.getUserDetails()
  this.getSystem()
},

methods: {
  //LOGOUT
    logOut() {
        this.$store.dispatch('destroyToken'),
        location.reload()
        },
    //GET USER DETAILS
    getUserDetails() {
      let userDetails = localStorage.getItem('userType')
      this.userType = userDetails
      if (this.userType == 'viewer') {
        this.disabled = true
      }
    },
    //GET FACTORY STATE
    getSystem() {
      http.get('/api/system-config')
        .then((res) => {
          this.current_config = res.data[0].system_config
        })
    },
    //UPDATE FACTORY STATE
    system_conf() {
      http.put('/api/system-config', { current_config: this.current_config })
        .catch((error) => {
          console.log(error)
        })
    },
   }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  text-decoration: none;
}

#submenu2 {
  width: 10px;
}

.wrapper {
  display: flex;
  position: relative;
}

/* --- Sidebar --- */
.wrapper .sidebar {
  width: 220px;
  height: 100vh;
  padding: 22px 14px;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--bg-elevated) !important;
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
}

.m4a_img {
  display: block;
  margin: 0 auto 22px;
}

/* outer nav list — force a clean vertical stack */
.wrapper .sidebar > ul {
  display: flex !important;
  flex-direction: column !important;
  gap: 2px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* every clickable row: top-level items, the config toggle, and submenu items */
.wrapper .sidebar > ul > li,
.wrapper .sidebar .dropdown-toggle,
.wrapper .sidebar .dropdown-menu > li {
  display: flex !important;
  align-items: center;
  width: 100%;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  font-weight: 550;
  font-size: 14px;
  line-height: 1.2;
  cursor: pointer;
  border: none;
  white-space: nowrap;
  float: none !important;
  transition: background 0.15s ease, color 0.15s ease;
}

/* icon spacing via margin (most reliable across the router-link <li>s) */
.wrapper .sidebar li i {
  width: 18px;
  min-width: 18px;
  margin-right: 11px;
  text-align: center;
  font-size: 14px;
}

.wrapper .sidebar > ul > li:hover,
.wrapper .sidebar .dropdown-toggle:hover,
.wrapper .sidebar .dropdown-menu > li:hover {
  background-color: var(--surface-2);
  color: var(--text);
}

/* active route (vue-router adds this class to the matched <li>) */
.wrapper .sidebar li.router-link-active {
  background-color: var(--accent-soft) !important;
  color: var(--accent) !important;
}

/* configuration dropdown wrapper sits in the column as a normal block */
.wrapper .sidebar ul.dropdown {
  display: block !important;
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}

.wrapper .sidebar .dropdown-menu {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 6px;
  box-shadow: var(--shadow);
  min-width: 190px;
}
.wrapper .sidebar .dropdown-menu > li {
  font-size: 13px;
}

.caret {
  margin-left: auto;
  color: var(--text-muted);
}

/* --- Main content --- */
.wrapper .main_content {
  width: 100%;
  margin-left: 220px;
  min-height: 100vh;
  background: var(--bg-base) !important;
}

.wrapper .main_content .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 28px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-elevated);
}

/* Factory State control (left of the title) */
.factory-state {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.factory-state__label {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}
.factory-state__select {
  min-width: 160px;
  height: 34px;
  padding: 4px 30px 4px 12px;
  font-size: 13px;
  font-weight: 600;
}

.header h1 {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
  letter-spacing: 0.02em;
  color: var(--text);
}

.wrapper .main_content .info {
  margin: 12px 20px;
  color: var(--text-muted);
  line-height: 1.5;
}

.wrapper .main_content .info div {
  margin-bottom: 20px;
}

.fa-mouse-pointer {
  -ms-transform: rotate(115deg);
  transform: rotate(115deg);
  margin-right: 6px;
  font-size: 10px;
}

img {
  width: 60px;
  height: 60px;
  border-radius: 14px;
}

a .fa-industry {
  color: var(--text-muted);
  display: inline !important;
}

/* --- Route transition --- */
.moveInUp-enter-active {
  animation: fadeIn 0.4s ease-in;
}
@keyframes fadeIn {
  0% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
}
.moveInUp-leave-active {
  animation: fadeIn 0.2s ease-in reverse;
}

/* --- Footer --- */
.footer {
  margin-top: auto;
  padding-top: 16px;
}
.sidebar .footer p {
  margin: 0 0 4px;
  color: var(--text-faint);
  font-size: 12px;
}
.sidebar .footer a {
  color: var(--accent);
  text-decoration: none;
  margin-left: 4px;
}
.sidebar .footer .help {
  display: inline-block;
  margin-top: 6px;
  color: var(--status-warning);
}
</style>